<template>
  <b-dropdown variant="ghost-blue" class="ui-dashboard-menu-dropdown invoice-element-selector-dropdown mr-2">
    <template #button-content>
      <font-awesome-icon icon="fa fa-circle-plus" class="mr-0" />
    </template>
    <b-dropdown-form>
      <template v-for="element in availableElements">
        <div
          class="dropdown-item"
          :class="{ disabled: element.unique && elementCount(element.type) > 0 }"
          :key="'aw_' + element.type"
          @click="toggleElement(element)"
        >
          <!-- <div class="item-controls item-controls--single">
            <font-awesome-icon v-if="elementCount(element_btn.type) < 1" :class="{}" :icon="'fa-regular fa-square'" />
            <font-awesome-icon v-else :class="{}" :icon="'fa-solid fa-square-check'" />
          </div> -->
          <span class="dropdown-item-title">{{ $gettext(element.name) }}</span>
        </div>
      </template>
    </b-dropdown-form>
    <!-- <b-dropdown-divider />
    <b-dropdown-item @click="resetConfig()">
      <font-awesome-icon :icon="'fa-solid fa-rotate-left'" />
      {{ $gettext('Reset to default') }}
    </b-dropdown-item> -->
  </b-dropdown>
</template>

<script>
export default {
  name: "InvoiceElementDropdown",
  data () {
    return {
    }
  },
  props: {
    availableElements: {
      type: Array,
      default: () => []
    },
    list: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleElement (element) {
      // if (this.elementCount(element) < 1) {
      //   this.addElement(element)
      // } else {
      //   this.removeElement(element)
      // }
      this.addElement(element)
    },
    addElement (element) {
      this.$emit('add-element', { element: element, list: this.list })
    },
    removeElement (element) {
      console.log('removeElement')
    },
    removeAllElements (element) {
      const element_list = this.getTempUserElements.filter(obj => obj.type === element)
      if (element_list.length > 0) {
        element_list.forEach(element => {
          this.$emit('remove-element', element.id)
        })
      }
    },
    elementCount (element) {
      return this.availableElements.filter(obj => obj.type === element).length
    },
    resetConfig () {
      this.$emit('reset-config', false)
    },
  },
}
</script>

<style lang="scss">
.invoice-element-selector-dropdown {
  .dropdown-toggle {
    &:after {
      display: none;
    }
  }
  .dropdown-item {
    width: 100%;
    line-height: 1.3;
    font-size: 15px;
    &.disabled {
      pointer-events: none;
      .element-count-badge {
        opacity: 0.2;
      }
      .item-controls {
        svg.svg-inline--fa {
          opacity: 0.3;
          color: $colorUnassigned;
        }
      }
    }
  }
  .dropdown-item-title {
    margin: 0 !important;
    padding: 0 0.5rem;
  }
  .b-dropdown-form {
    padding: 0;
    user-select: none;
  }
  .item-controls {
    margin-left: auto;
    display: flex;
    align-items: center;
    &--single {
      margin: 0;
    }
    svg.svg-inline--fa {
      font-size: 17px;
      color: $colorBrand;
      font-size: 20px;
      opacity: 0.6;
      margin-right: 0px !important;
      &:first-child {
        margin-right: 3px !important;
      }
      transition: all 0.2s ease;
      &:not(.disabled) {
        cursor: pointer;
        &:hover {
          color: $colorBrand800;
          opacity: 1;
        }
      }
      &.disabled {
        opacity: 0.3;
        color: $colorUnassigned;
      }
    }
  }
}

.element-premium-badge {
  border-radius: 12px;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 1;
  padding: 5px 10px;
  padding-bottom: 4px;
  background: $colorBrand;
  color: #ffffff;
  margin: 0 !important;
  margin-left: 15px !important;
}

.element-count-badge {
  border-radius: 50em;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 1;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $colorBrand;
  margin: 0 !important;
  margin-right: 5px;
  color: white;
  opacity: 0.6;
  &.none {
    opacity: 0.4;
    background: $colorUnassigned;
  }
}
</style>